import React from 'react';
import { Link } from 'react-router-dom';


const Breadcrumb = props => (
    <ul className="breadcrumb">
        { props.from.map(item => <li key={item.label}><Link to={ item.link }>{ item.label }</Link></li>) }
        <li>{ props.current }</li>
    </ul>
);

export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/components/UI/Breadcrumb.js